import "core-js/modules/es.symbol";
import "core-js/modules/es.symbol.description";
import "core-js/modules/es.symbol.iterator";
import "core-js/modules/es.array.concat";
import "core-js/modules/es.array.from";
import "core-js/modules/es.array.iterator";
import "core-js/modules/es.array.join";
import "core-js/modules/es.array.slice";
import "core-js/modules/es.object.to-string";
import "core-js/modules/es.regexp.constructor";
import "core-js/modules/es.regexp.to-string";
import "core-js/modules/es.string.iterator";
import "core-js/modules/es.string.replace";
import "core-js/modules/es.string.split";
import "core-js/modules/web.dom-collections.iterator";
import "regenerator-runtime/runtime";

var _marked =
/*#__PURE__*/
regeneratorRuntime.mark(doBuildNewPath),
    _marked2 =
/*#__PURE__*/
regeneratorRuntime.mark(doRedirectPricingPages),
    _marked3 =
/*#__PURE__*/
regeneratorRuntime.mark(doRedirectGenericPages),
    _marked4 =
/*#__PURE__*/
regeneratorRuntime.mark(doChangeLocation),
    _marked5 =
/*#__PURE__*/
regeneratorRuntime.mark(loadSaga),
    _marked6 =
/*#__PURE__*/
regeneratorRuntime.mark(watchSaga);

function _toConsumableArray(arr) { return _arrayWithoutHoles(arr) || _iterableToArray(arr) || _nonIterableSpread(); }

function _nonIterableSpread() { throw new TypeError("Invalid attempt to spread non-iterable instance"); }

function _arrayWithoutHoles(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } }

function _toArray(arr) { return _arrayWithHoles(arr) || _iterableToArray(arr) || _nonIterableRest(); }

function _iterableToArray(iter) { if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

import { fetchEntityIfNeeded } from '@classpass/saga-tools';
import { DALNotFoundError } from '@classpass/dal';
import { replace as replacePath } from 'react-router-redux';
import { all, call, put, fork, takeEvery, select } from 'redux-saga/effects';
import * as logger from 'universal-logger';
import { glsLocation, msas, cms } from 'redux/saga/entities/bound';
import { getUserLocation } from 'redux/saga/helpers';
import { persistUserLocation } from 'redux/saga/helpers/location';
import { getMsaFromPath } from 'redux/saga/helpers/msas';
import { pathSelector } from 'redux/saga/selectors/request';
import { msaById } from 'redux/saga/selectors/msas';
import { addGenericNotification, addFailureNotification } from 'features/Banners/Banners.reducer';
import { GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS } from 'constants/promotions';
import { openLocationModal } from 'containers/LocationModal/location.saga';
import { setMsaId } from 'redux/modules/features/homepage';
import { userErrorMessages as messages } from 'components/Errors/Error.messages';
export var changeLocation = function changeLocation(lat, lon) {
  return {
    type: 'CHANGE_LOCATION',
    lat: lat,
    lon: lon
  };
};
export function doBuildNewPath(client, _ref) {
  var path, newMsaId, _ref2, _ref3, msaList, oldMsa, newMsa, newPath, _path$split, _path$split2, nil, page, rest;

  return regeneratorRuntime.wrap(function doBuildNewPath$(_context) {
    while (1) {
      switch (_context.prev = _context.next) {
        case 0:
          path = _ref.path, newMsaId = _ref.newMsaId;
          _context.next = 3;
          return all([call(fetchEntityIfNeeded, msas, [client]), call(getMsaFromPath, client, path)]);

        case 3:
          _ref2 = _context.sent;
          _ref3 = _slicedToArray(_ref2, 2);
          msaList = _ref3[0];
          oldMsa = _ref3[1];
          newMsa = msaById(msaList, newMsaId);

          if (newMsa && oldMsa) {
            newPath = path.replace(oldMsa.alias, newMsa.alias);
          } else if (newMsa) {
            _path$split = path.split('/'), _path$split2 = _toArray(_path$split), nil = _path$split2[0], page = _path$split2[1], rest = _path$split2.slice(2);
            newPath = [nil, page, newMsa.alias].concat(_toConsumableArray(rest)).join('/');
          } else if (oldMsa) {
            newPath = path.replace(oldMsa.alias, '').replace('//', '/');
          } else {
            newPath = path;
          }

          return _context.abrupt("return", newPath);

        case 10:
        case "end":
          return _context.stop();
      }
    }
  }, _marked);
}
export function doRedirectPricingPages(client, _ref4) {
  var path, newMsaId, newPath, newCmsData;
  return regeneratorRuntime.wrap(function doRedirectPricingPages$(_context2) {
    while (1) {
      switch (_context2.prev = _context2.next) {
        case 0:
          path = _ref4.path, newMsaId = _ref4.newMsaId;

          if (newMsaId) {
            _context2.next = 5;
            break;
          }

          _context2.next = 4;
          return put(replacePath('/'));

        case 4:
          return _context2.abrupt("return");

        case 5:
          _context2.next = 7;
          return call(doBuildNewPath, client, {
            path: path,
            newMsaId: newMsaId
          });

        case 7:
          newPath = _context2.sent;
          _context2.prev = 8;
          _context2.next = 11;
          return call(fetchEntityIfNeeded, cms, [client, newPath]);

        case 11:
          newCmsData = _context2.sent;

          if (!newCmsData) {
            _context2.next = 15;
            break;
          }

          _context2.next = 15;
          return put(replacePath(newPath));

        case 15:
          _context2.next = 26;
          break;

        case 17:
          _context2.prev = 17;
          _context2.t0 = _context2["catch"](8);

          if (!(_context2.t0 instanceof DALNotFoundError)) {
            _context2.next = 25;
            break;
          }

          _context2.next = 22;
          return put(replacePath("/pricing/".concat(GET_CLASSPASS_DEFAULT_PROMOTION_ALIAS)));

        case 22:
          _context2.next = 24;
          return put(addGenericNotification('Uh oh! That promotion isn’t valid in your city. Choose a plan below to get started.', {
            timeout: 0
          }));

        case 24:
          return _context2.abrupt("return");

        case 25:
          throw _context2.t0;

        case 26:
        case "end":
          return _context2.stop();
      }
    }
  }, _marked2, null, [[8, 17]]);
}
export function doRedirectGenericPages(client, _ref5) {
  var path, newMsaId, newPath, newCmsData;
  return regeneratorRuntime.wrap(function doRedirectGenericPages$(_context3) {
    while (1) {
      switch (_context3.prev = _context3.next) {
        case 0:
          path = _ref5.path, newMsaId = _ref5.newMsaId;
          _context3.next = 3;
          return call(doBuildNewPath, client, {
            path: path,
            newMsaId: newMsaId
          });

        case 3:
          newPath = _context3.sent;
          _context3.prev = 4;
          _context3.next = 7;
          return call(fetchEntityIfNeeded, cms, [client, newPath]);

        case 7:
          newCmsData = _context3.sent;

          if (!newCmsData) {
            _context3.next = 11;
            break;
          }

          _context3.next = 11;
          return put(replacePath(newPath));

        case 11:
          _context3.next = 20;
          break;

        case 13:
          _context3.prev = 13;
          _context3.t0 = _context3["catch"](4);

          if (!(_context3.t0 instanceof DALNotFoundError)) {
            _context3.next = 19;
            break;
          }

          _context3.next = 18;
          return put(addGenericNotification('Please provide a valid location.', {
            timeout: 0
          }));

        case 18:
          return _context3.abrupt("return");

        case 19:
          throw _context3.t0;

        case 20:
        case "end":
          return _context3.stop();
      }
    }
  }, _marked3, null, [[4, 13]]);
}
export function doChangeLocation(client, _ref6) {
  var lat, lon, _ref7, _ref8, _ref8$, locationData, msa, newMsaId, path;

  return regeneratorRuntime.wrap(function doChangeLocation$(_context4) {
    while (1) {
      switch (_context4.prev = _context4.next) {
        case 0:
          lat = _ref6.lat, lon = _ref6.lon;
          _context4.prev = 1;
          _context4.next = 4;
          return all([call(fetchEntityIfNeeded, glsLocation, [client, lat, lon]), call(persistUserLocation, lat, lon)]);

        case 4:
          _ref7 = _context4.sent;
          _ref8 = _slicedToArray(_ref7, 1);
          _ref8$ = _ref8[0];
          locationData = _ref8$ === void 0 ? {} : _ref8$;
          msa = locationData.msa || {};

          if (!(msa.id && msa.package_purchase)) {
            _context4.next = 13;
            break;
          }

          _context4.t0 = msa.id;
          _context4.next = 16;
          break;

        case 13:
          _context4.next = 15;
          return call(openLocationModal);

        case 15:
          _context4.t0 = _context4.sent;

        case 16:
          newMsaId = _context4.t0;
          _context4.next = 19;
          return put(setMsaId(newMsaId));

        case 19:
          _context4.next = 21;
          return select(pathSelector);

        case 21:
          path = _context4.sent;

          if (!new RegExp('^/pricing/').test(path)) {
            _context4.next = 27;
            break;
          }

          _context4.next = 25;
          return call(doRedirectPricingPages, client, {
            path: path,
            newMsaId: newMsaId
          });

        case 25:
          _context4.next = 30;
          break;

        case 27:
          if (new RegExp('^/locations/').test(path)) {
            _context4.next = 30;
            break;
          }

          _context4.next = 30;
          return call(doRedirectGenericPages, client, {
            path: path,
            newMsaId: newMsaId
          });

        case 30:
          _context4.next = 36;
          break;

        case 32:
          _context4.prev = 32;
          _context4.t1 = _context4["catch"](1);
          _context4.next = 36;
          return all([call(logger.error, 'LocationSelector: Could not change location using lat, lon', "".concat(lat, ", ").concat(lon), _context4.t1), put(addFailureNotification(messages.genericMessage))]);

        case 36:
        case "end":
          return _context4.stop();
      }
    }
  }, _marked4, null, [[1, 32]]);
}
export function loadSaga(client) {
  return regeneratorRuntime.wrap(function loadSaga$(_context5) {
    while (1) {
      switch (_context5.prev = _context5.next) {
        case 0:
          _context5.next = 2;
          return all([call(fetchEntityIfNeeded, msas, [client]), call(getUserLocation, client)]);

        case 2:
        case "end":
          return _context5.stop();
      }
    }
  }, _marked5);
}
export function watchSaga(client) {
  return regeneratorRuntime.wrap(function watchSaga$(_context6) {
    while (1) {
      switch (_context6.prev = _context6.next) {
        case 0:
          _context6.next = 2;
          return fork(takeEvery, changeLocation().type, doChangeLocation, client);

        case 2:
        case "end":
          return _context6.stop();
      }
    }
  }, _marked6);
}